export interface ButtonColour {
  id: number;
  key: string;
  name: string;
  colour: string;
}

const buttonColours: ButtonColour[] = [
  {
    id: 1,
    key: 'grey',
    name: 'Grey',
    colour: '#cccccc',
  },
  {
    id: 2,
    key: 'darkGrey',
    name: 'Dark Grey',
    colour: '#555555',
  },
  {
    id: 3,
    key: 'darkOrange',
    name: 'Dark Orange',
    colour: '#e24c00',
  },
  {
    id: 4,
    key: 'darkBlue',
    name: 'Dark Blue',
    colour: '#0098dc',
  },
  {
    id: 5,
    key: 'lightOrange',
    name: 'Light Orange',
    colour: '#ff7a13',
  },
  {
    id: 6,
    key: 'lightBlue',
    name: 'Light Blue',
    colour: '#11c6ff',
  },
  {
    id: 7,
    key: 'black',
    name: 'Black',
    colour: '#000000',
  },
  {
    id: 8,
    key: 'darkGreen',
    name: 'Dark Green',
    colour: '#00ac00',
  },
  {
    id: 9,
    key: 'red',
    name: 'Red',
    colour: '#eb340a',
  },
  {
    id: 10,
    key: 'lightRed',
    name: 'Light Red',
    colour: '#fc451b',
  },
  {
    id: 11,
    key: 'pink',
    name: 'Pink',
    colour: '#ff99ed',
  },
  {
    id: 12,
    key: 'greyYellow',
    name: 'Grey Yellow',
    colour: '#aab67c',
  },
  {
    id: 13,
    key: 'navyBlue',
    name: 'Navy Blue',
    colour: '#000080',
  },
  {
    id: 14,
    key: 'deepGreen',
    name: 'Deep Green',
    colour: '#305a39',
  },
];

export default buttonColours;
